<template>
  <a-drawer class="pubilc-drawer" v-bind="$attrs">
    <slot />
    <template #footer>
      <slot name="footer" />
    </template>
  </a-drawer>
</template>
<script>
import { Drawer } from "ant-design-vue";
export default {
  name: "tsl-drawer",
  components: {
    [Drawer.name]: Drawer
  }
};
</script>
<style lang="less">
.pubilc-drawer {
  text-align: left;
  .ant-drawer-title {
    color: #1d2129;
    font-family: PingFangSC-Medium, PingFang SC;
  }
  .ant-drawer-header-title {
    flex-direction: row-reverse;
    width: 100%;
    .ant-drawer-close {
      margin-right: 0;
    }
  }
  .ant-drawer-header {
    border-bottom: 1px solid #f2f3f5;
  }
  .ant-drawer-footer {
    padding: 12px 24px;
    text-align: left;
  }
  .ant-drawer-close {
    width: 16px;
    height: 16px;
    background: url(../../assets/svg/drawer_close.svg) no-repeat center right;
    .anticon-close {
      display: none;
    }
  }
}
</style>
